module.exports = "mat4 translation(vec3 t) {\nreturn mat4(\n1, 0, 0, 0,\n0, 1, 0, 0,\n0, 0, 1, 0,\nt.x, t.y, t.z, 1\n);\n}"